import { createI18n } from "vue-i18n";
import { messages } from "@/locales/index.js";

const i18nInstance = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages: messages
});

export default i18nInstance;

export const i18n = i18nInstance.global;
